import BaseFormPresenter from "../../../base/BaseFormPresenter";

class SuppliersFormPagePresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase) {
    super(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase);
    this.getObjectUseCase = getObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  async onSubmit(obj) {
    const collection = this.view.getCollectionName();
    const clientId = this.view.getClientId();
    const user = this.view.getCurrentUser();

    let supplierObject = { ...obj };

    try {
      this.view.showProgress();

      if (supplierObject.editor) {
        supplierObject.editor = { id: supplierObject.editor?.id };
      }

      if (supplierObject.creator) {
        supplierObject.creator = { id: supplierObject.creator?.id };
      }

      if (supplierObject.client) {
        supplierObject.client = { id: supplierObject.client?.id };
      } else {
        supplierObject.client = { id: clientId || user.client?.id };
      }

      const object = await this.upsertUseCase.execute(
        collection,
        supplierObject,
      );

      this.view.hideProgress();
      this.view.navigateTo("/suppliers");
      if (!supplierObject.id) {
        this.view.showSuccess("Submitted Successfully!");
      } else {
        this.view.showSuccess("Data Updated Successfully!");
      }
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default SuppliersFormPagePresenter;
